export default "__VITE_ASSET__FiAIE6c5__"